module.exports = __webpack_public_path__ + "media/images/tutorial_header_sp1-01-1a3f92dd999e675b7b2fd8c63928f5e9.png";